module.exports = __webpack_public_path__ + "static/media/loc2_img6.bb6d5ce3.jpg";